import { render } from "./MButton.vue?vue&type=template&id=6da4df19"
import script from "./MButton.vue?vue&type=script&lang=ts"
export * from "./MButton.vue?vue&type=script&lang=ts"
script.render = render

export default script